export const EVERYTHING_IN_ESSENTIAL_LINE = 'Everything in Essential'

interface ExpertSupportCopy {
  heading: string
  bullets: string[]
}

const POINT_OF_CONTACT_BULLET =
  'A dedicated expert is your primary point of contact all year and gets to know your practice and your goals.'

const CHECK_INS_BULLET =
  'Four check-ins a year, where your expert reviews your books, sends an agenda, and follows up with a written summary.'

const TEAM_ALIGNMENT_BULLET =
  'Your expert works with your bookkeeper and tax preparer to keep your books, taxes and planning aligned.'

const PAYING_EXPERT_SUPPORT: ExpertSupportCopy = {
  heading: 'Dedicated expert support:',
  bullets: [
    POINT_OF_CONTACT_BULLET,
    'Unlimited 1:1 meetings with your expert from day one, from onboarding to quarterly tax moments (as available).',
    CHECK_INS_BULLET,
    TEAM_ALIGNMENT_BULLET,
  ],
}

const TRIAL_EXPERT_SUPPORT: ExpertSupportCopy = {
  heading: 'Dedicated expert support (available after your trial completes):',
  bullets: [
    POINT_OF_CONTACT_BULLET,
    'Unlimited 1:1 meetings with your expert after your trial completes, from onboarding to quarterly tax moments (as available).',
    CHECK_INS_BULLET,
    TEAM_ALIGNMENT_BULLET,
  ],
}

export const dedicatedExpertSupportCopy = (
  isTrial: boolean
): ExpertSupportCopy => (isTrial ? TRIAL_EXPERT_SUPPORT : PAYING_EXPERT_SUPPORT)
